// PlayerCard open tracking.
//
// Lives in its own module rather than mockAnalytics/projlabAnalytics because
// the card is opened from surfaces owned by both (player lists, tier builder,
// projection tables) — no single funnel owns it.
//
// Gating is handled upstream: analyticsGate.js stubs posthog.capture entirely
// when analytics is suppressed, so this call site needs no host/env checks.

import posthog from "posthog-js";

// Analytics must never break a card open — swallow capture failures.
function safeCapture(event, properties) {
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}

// Fired from the context's openPlayerCard, so every open path is covered by
// construction. `source` identifies which surface the user came from — the
// whole point of the event is telling us whether the new stats icon is
// actually getting discovered, and where.
export function capturePlayerCardOpened(source) {
  safeCapture("player_card_opened", { source: source || "unknown" });
}
